import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { Field, Form, Formik } from "formik";
// import { GeneralTextInput } from "../Custom-Forms/General-Text-Input";
import { GeneralTextAreaField } from "../Custom-Forms/General-Text-Area-Field";
import { GeneralCheckBox } from "../Custom-Forms/General-Check-Box";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./Sign-Up.css";
import { axiosInstance } from "../../utils/axios-instance";
import { SignUpSubmission } from "./Sign-Up-Submission";
import PhoneInput from "react-phone-number-input";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { fetchSignIn } from "../../store/thunks/fetch-sign-in-thunk";
import { selectSignIn } from "../../store/slices/signed-in-slice";

import { FaEye } from "react-icons/fa";
import { FaEyeSlash } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import { Button } from "react-bootstrap";
import { FormikOnError } from "../Custom-Forms/Formik-On-Error";
import {toast} from 'react-toastify';


export const SignUp = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const isSignedIn = useSelector(selectSignIn);
    const [submitted, setSubmitted] = useState(false);

    const [showPassword, setShowPassword] = useState(false);

    const ToastID = React.useRef(null)

    // If user is signed out,
    // redirect to the home page
    useEffect(() => {
        if (isSignedIn) {
            navigate("/");
        }
    }, [dispatch, isSignedIn, navigate]);

    let signUpValidation = Yup.object({
        firstName: Yup.string()
            .max(100, "First Name is too long. 100 Characters Max")
            .required("Your First Name is Required"),
        lastName: Yup.string()
            .max(100, "Last Name is too long. 100 Characters Max")
            .required("Your Last Name is Required"),
        email: Yup.string()
            .email("Invalid Email Address")
            .max(155, "Email is too long. 155 Characters Max")
            .required("A Valid Email is Required"),
        password: Yup.string()
            .min(8, "Password minimum length is 8 characters.")
            .matches(
                /([a-z]{1,})/,
                "Password must include one lowercase letter.",
            )
            .matches(
                /([A-Z]{1,})/,
                "Password must include one uppercase letter.",
            )
            .matches(/([0-9]{1,})/, "Password must include a number.")
            .matches(
                /([<>,./?'"{}[\]\\|!@#$%^&*()_+=-]{1,})/,
                "Password must include a special character.",
            )
            .required("A Valid Password is Required"),
        passwordCheck: Yup.string()
            .oneOf([Yup.ref("password"), null], "Passwords need to match")
            .required("Passwords must match"),
        acceptedTerms: Yup.boolean()
            .required("Required")
            .oneOf([true], "You must accept the terms and conditions"),
        phoneNumber: Yup.string()
            .max(30, "First Name is too long. 30 Characters Max")
            .required("A Valid Phone Number is Required"),
    });

    return (
        <>
            <Container className="bg-body-secondary rounded-3 justify-content-center my-4 py-4">
                <h1>Create Account</h1>
                <Row className="card-background card-font">
                    <Formik
                        initialValues={{
                            firstName: "",
                            lastName: "",
                            email: "",
                            password: "",
                            passwordCheck: "",
                            acceptedTerms: false,
                            phoneNumber: "",
                        }}
                        validationSchema={signUpValidation}
                        onSubmit={async (values, { setStatus }) => {
                            try {
                                ToastID.current = toast.loading(`Attempting to Sign Up`, {theme: "colored", containerId:"root", autoClose: "5000"} )
                                let res = await axiosInstance({
                                    method: "post",
                                    url: "/sign-up",
                                    headers: {
                                        "Content-Type": "application/json",
                                    },
                                    data: {
                                        email: values.email,
                                        firstName: values.firstName,
                                        lastName: values.lastName,
                                        password: values.password,
                                        phoneNumber: values.phoneNumber,
                                    },
                                });
                                toast.update(ToastID.current , {render: `Successfully Signed Up. Check Your Email`, type: "success", isLoading: false, theme: "colored", autoClose: "3500",  containerId:"root"} )
                                setStatus({ error: false });
                                setSubmitted(true);
                                dispatch(fetchSignIn());
                            } catch (error) {
                                toast.update(ToastID.current , {render: `Failed to Sign Up`, type: "error", isLoading: false, theme: "colored", autoClose: "5000", containerId:"root"})
                                setStatus({ error: true });
                                setTimeout(() => {
                                    setStatus({ error: false });
                                });

                                console.error(error);
                                return Promise.reject(error);
                            }
                        }}
                    >
                        <Form>
                            <FormikOnError>
                                {!submitted && (
                                    <>
                                        <Row className="mx-0">
                                            <GeneralTextAreaField
                                                autoFocus
                                                label="First Name:"
                                                className="form-control"
                                                component="input"
                                                name="firstName"
                                                rows="1"
                                                placeholder="First Name"
                                                autoComplete="given-name"
                                                aria-required="true"
                                            />
                                        </Row>
                                        <Row className="mx-0 ">
                                            <GeneralTextAreaField
                                                label="Last Name:"
                                                className="form-control"
                                                component="input"
                                                name="lastName"
                                                rows="1"
                                                placeholder="Last Name"
                                                autoComplete="family-name"
                                                aria-required="true"
                                            />
                                        </Row>

                                        <Row className="mx-0">
                                            <GeneralTextAreaField
                                                label="Email:"
                                                className="form-control"
                                                component="input"
                                                name="email"
                                                rows="1"
                                                placeholder="name@example.com"
                                                autoComplete="email"
                                                aria-required="true"
                                            />
                                        </Row>

                                        <Row className="mx-0">
                                            <Col xs={12}>
                                                <Row>
                                                    <label
                                                        className="label px-0 mx-0"
                                                        htmlFor={"phoneNumber"}
                                                    >
                                                        Phone Number:
                                                    </label>
                                                </Row>

                                                <Row>
                                                    <Field name="phoneNumber">
                                                        {({ field, meta }) => (
                                                            <div
                                                                style={{
                                                                    padding: 0,
                                                                }}
                                                            >
                                                                <PhoneInput
                                                                    name="phoneNumber"
                                                                    international
                                                                    countryCallingCodeEditable={
                                                                        false
                                                                    }
                                                                    className={
                                                                        "form-control " +
                                                                            meta.touched &&
                                                                        meta.error
                                                                            ? "is-invalid"
                                                                            : ""
                                                                    }
                                                                    defaultCountry="US"
                                                                    placeholder="Enter phone number"
                                                                    {...field}
                                                                    aria-label="Phone Number"
                                                                    aria-required="true"
                                                                    aria-invalid={
                                                                        meta.touched &&
                                                                        meta.error
                                                                            ? "true"
                                                                            : null
                                                                    }
                                                                    aria-describedby={
                                                                        meta.touched &&
                                                                        meta.error
                                                                            ? "phoneNumber-error"
                                                                            : ""
                                                                    }
                                                                    onChange={(
                                                                        phoneNumber,
                                                                    ) => {
                                                                        const changedEvent =
                                                                            {
                                                                                target: {
                                                                                    name: "phoneNumber",
                                                                                    value: phoneNumber,
                                                                                },
                                                                            };
                                                                        field.onChange(
                                                                            changedEvent,
                                                                        );
                                                                    }}
                                                                />
                                                                {meta.touched &&
                                                                    meta.error && (
                                                                        <div
                                                                            aria-hidden="true"
                                                                            className="text-danger"
                                                                            id="phoneNumber-error"
                                                                        >
                                                                            {
                                                                                meta.error
                                                                            }
                                                                        </div>
                                                                    )}
                                                            </div>
                                                        )}
                                                    </Field>
                                                </Row>
                                            </Col>
                                        </Row>

                                        <Row className="mx-0">
                                            <Col>
                                                <GeneralTextAreaField
                                                    label="Password:"
                                                    className="form-control"
                                                    component="input"
                                                    name="password"
                                                    type={
                                                        showPassword
                                                            ? "text"
                                                            : "password"
                                                    }
                                                    rows="1"
                                                    placeholder="Password"
                                                    autoComplete="new-password"
                                                    aria-required="true"
                                                />
                                                <GeneralTextAreaField
                                                    label="Confirm Password:"
                                                    className="form-control"
                                                    component="input"
                                                    name="passwordCheck"
                                                    type={
                                                        showPassword
                                                            ? "text"
                                                            : "password"
                                                    }
                                                    rows="1"
                                                    placeholder="Confirm Password"
                                                    autoComplete="new-password"
                                                    aria-required="true"
                                                />
                                                <Col
                                                    aria-hidden="true"
                                                    className="d-flex justify-content-end mt-2"
                                                >
                                                    <p>
                                                        Password Requirements:
                                                        <br></br>- Password
                                                        minimum length is 8
                                                        characters.
                                                        <br></br>- Password must
                                                        include one lowercase
                                                        letter.<br></br>-
                                                        Password must include
                                                        one uppercase letter.
                                                        <br></br>- Password must
                                                        include a number.
                                                        <br></br>- Password must
                                                        include a special
                                                        character.
                                                    </p>
                                                </Col>
                                                <p className="visually-hidden">
                                                    Password Requirements:
                                                    Password minimum length is 8
                                                    characters. Password must
                                                    include one lowercase
                                                    letter. Password must
                                                    include one uppercase
                                                    letter. Password must
                                                    include a number. Password
                                                    must include a special
                                                    character.
                                                </p>
                                            </Col>
                                        </Row>

                                        <Row className="mx-0 mt-2">
                                            <Col
                                                xs={10}
                                                className="d-flex justify-content-start"
                                            >
                                                <GeneralCheckBox
                                                    name="acceptedTerms"
                                                    aria-label="Accept Terms and Conditions"
                                                    aria-required="true"
                                                    // aria-invalid={errors.acceptedTerms && touched.firstName ? 'true' : null}
                                                    // aria-describedby={errors.acceptedTerms && touched.firstName ? 'accecpted-terms-error' : null}
                                                >
                                                    <span
                                                        style={{
                                                            marginLeft: "10px",
                                                        }}
                                                    >
                                                        I have read and agreed
                                                        to the
                                                        <Link
                                                            to="/terms-of-use"
                                                            className="links-signup"
                                                        >
                                                            Terms of Use
                                                        </Link>{" "}
                                                        |
                                                        <Link
                                                            to="/privacy-policy"
                                                            className="links-signup"
                                                        >
                                                            Privacy Policy
                                                        </Link>{" "}
                                                        |
                                                        <Link
                                                            to="/disclaimer"
                                                            className="links-signup"
                                                        >
                                                            Disclaimer
                                                        </Link>
                                                    </span>
                                                </GeneralCheckBox>
                                            </Col>
                                            <Col
                                                xs={2}
                                                className="d-flex justify-content-end"
                                                aria-hidden="true"
                                            >
                                                <Button
                                                    id="check"
                                                    style={{
                                                        backgroundColor:
                                                            "white",
                                                        outline: "none",
                                                    }}
                                                    onClick={() =>
                                                        setShowPassword(
                                                            (prev) => !prev,
                                                        )
                                                    }
                                                    aria-label="Show/Hide password toggle"
                                                >
                                                    <IconContext.Provider
                                                        value={{
                                                            color: "blue",
                                                            size: "20px",
                                                        }}
                                                    >
                                                        {showPassword ? (
                                                            <FaEyeSlash />
                                                        ) : (
                                                            <FaEye />
                                                        )}
                                                    </IconContext.Provider>
                                                </Button>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                                <Row>
                                    <Col>
                                        <SignUpSubmission
                                            isSubmitted={submitted}
                                        />
                                    </Col>
                                </Row>
                            </FormikOnError>
                        </Form>
                    </Formik>
                </Row>
            </Container>
        </>
    );
};
